<template>
  <div id="emergencyCTA">
    <div class="row align-items-center">
      <div class="col-md-3 mb-4 mb-md-0">
        <h3>Have an Emergency or rush order?</h3>
      </div>
      <div class="col-md-6 mb-4 mb-md-0">
        <p>
          Our Service Portal should never be used to order breakdown parts.
          Please call {{companyPhone}} for customer service. For emergency afterhour services please page 704-832-0455.
        </p>
      </div>
      <div class="col-md-3">
        <a href="https://www.jcsteele.com/contact-us/" class="btn btn-dark" target="_blank">Contact us today</a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import APIService from "@/assets/js/APIService";
const apiService = new APIService();
	export default {
		name: "EmergencyCta",
		mounted() {
			this.settingsDetails();

			Vue.filter("companyPhone", function(companyPhone) {
			return companyPhone
				.replace(/[^0-9]/g, "")
				.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
			});
		},
		data() {
			return {
				companyPhone: "",
			}
		},
		methods: {
			settingsDetails() {
			apiService
				.getCompanySettings()
				.then((request) => {
				this.settingsSuccessful(request);
				})
				.catch((err) => this.settingsFailed(err));
			},
			settingsSuccessful(request) {
				(this.companyPhone = request.companyPhone);
			},
			settingsFailed(err) {
				this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
					title: err.error.response.data.title,
					autoHideDelay: 10000,
					appendToast: false,
					variant: "danger",
					solid: true,
				});
			},
		}
	};
</script>
